<template>
<div class="flex flex-column flex-end relative">
    <svg ref="gittertraeger" viewBox="0 0 509 713" class="gittertraeger npe no-shrink w-auto" fill="none" v-show="baustoff == 'Halbfertigteil' && dickeHalbfertigteil > 0 && HKName !== ''" :style="{ height: ((dickeHalbfertigteil - BetondeckungUnten + zwischenlageUnten + querbewehrung + sl_unterstuetzungshoehe + (Hohlkoerper.unterstuetzungshoehe / 2)) / deckendicke) * gHeight + 'px'}" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;">

    <g transform="matrix(1,0,0,1,-884.464,-378.809)">
        <g transform="matrix(1.47403,0.374743,-0.241412,0.949582,-3.52454,-1225.31)">
            <rect x="962.931" y="1350.42" width="22.708" height="696.818" style="fill:none;stroke:rgb(217,83,18);stroke-width:4.89px;stroke-linecap:round;stroke-miterlimit:1.5;stroke-dasharray:14.66,14.66,0,0;stroke-dashoffset:4.89;"/>
        </g>
        <g transform="matrix(1,0,0,1,7.10184,-916.253)">
            <circle cx="899.288" cy="1979.81" r="18.8" style="fill:none;stroke:rgb(217,83,18);stroke-width:6.25px;stroke-linecap:round;stroke-miterlimit:1.5;stroke-dasharray:18.75,18.75,0,0;stroke-dashoffset:6.25;"/>
        </g>
        <g transform="matrix(1.3194,0,0,1.3194,-47.9432,-2205.43)">
            <circle cx="899.288" cy="1979.81" r="18.8" style="fill:none;stroke:rgb(217,83,18);stroke-width:4.74px;stroke-linecap:round;stroke-miterlimit:1.5;stroke-dasharray:14.21,14.21,0,0;stroke-dashoffset:4.74;"/>
        </g>
        <g transform="matrix(-1.47403,0.374743,0.241412,0.949582,2280.69,-1225.31)">
            <rect x="962.931" y="1350.42" width="22.708" height="696.818" style="fill:none;stroke:rgb(217,83,18);stroke-width:4.89px;stroke-linecap:round;stroke-miterlimit:1.5;stroke-dasharray:14.66,14.66,0,0;stroke-dashoffset:4.89;"/>
        </g>
        <g transform="matrix(-1,0,0,1,2270.06,-916.253)">
            <circle cx="899.288" cy="1979.81" r="18.8" style="fill:none;stroke:rgb(217,83,18);stroke-width:6.25px;stroke-linecap:round;stroke-miterlimit:1.5;stroke-dasharray:18.75,18.75,0,0;stroke-dashoffset:6.25;"/>
        </g>
    </g>

    </svg>
    <!-- <div class="bewehrung-circle hft-circle-left" :style="{ height: bewHFT + 'px', width: bewHFT + 'px', left: -bewHFT + 'px'}"></div>
    <div class="bewehrung-circle hft-circle-right" :style="{ height: bewHFT + 'px', width: bewHFT + 'px', right: -bewHFT + 'px'}"></div> -->
    <!-- <svg class="hft-circle-left" :style="{ height: bewHFT + 'px', width: bewHFT + 'px', left: -(bewHFT*0.6) + 'px', marginBottom: bewHFT*0.5 + 'px'}" viewBox="0 0 68 68" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(1,0,0,1,-1336.97,-1029.62)">
        <g transform="matrix(-1.63881,0,0,1.63881,2844.66,-2180.97)">
            <circle cx="899.288" cy="1979.81" r="18.8" style="fill:none;stroke:rgb(214,70,0);stroke-width:4.89px;stroke-linecap:round;stroke-miterlimit:1.5;stroke-dasharray:7.63,7.63,7.63,0;stroke-dashoffset:3.81;"/>
        </g>
    </g>
    </svg>
    <svg class="hft-circle-right" :style="{ height: bewHFT + 'px', width: bewHFT + 'px', right: -(bewHFT*0.6) + 'px', marginBottom: bewHFT*0.5 + 'px'}" viewBox="0 0 68 68" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(1,0,0,1,-1336.97,-1029.62)">
        <g transform="matrix(-1.63881,0,0,1.63881,2844.66,-2180.97)">
            <circle cx="899.288" cy="1979.81" r="18.8" style="fill:none;stroke:rgb(214,70,0);stroke-width:4.89px;stroke-linecap:round;stroke-miterlimit:1.5;stroke-dasharray:7.63,7.63,7.63,0;stroke-dashoffset:3.81;"/>
        </g>
    </g>
    </svg> -->
</div>
</template>

<script>

export default {
  data() {
    return {
    };
  },
  props: {
      'baustoff': String,
      'dickeHalbfertigteil': Number,
      'HKName': String,
      'BetondeckungUnten': Number,
      'zwischenlageUnten': Number, 
      'querbewehrung': Number, 
      'sl_unterstuetzungshoehe': Number,
      'Hohlkoerper': Object,
      'deckendicke': Number,
      'gHeight': Number,
      'bewHFT': Number
  }
}
</script>
<style>

</style>